import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="hero-title">MINERVA</h1>
            <p className="hero-subtitle">
              Ewolucja przemysłowej automatyzacji
            </p>
            <p className="hero-description">
              Platforma inteligentnej automatyzacji zwiększająca wydajność i redukująca koszty operacyjne
            </p>
            <div className="hero-cta">
              <a href="#features" className="button button-primary">
                Odkryj możliwości
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 13l5 5 5-5M7 6l5 5 5-5"/>
                </svg>
              </a>
              <a href="#contact" className="button button-secondary">
                Skontaktuj się
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-value">25%</span>
                <span className="stat-label">Redukcja kosztów</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">18%</span>
                <span className="stat-label">Wzrost wydajności</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">98%</span>
                <span className="stat-label">Zadowolonych klientów</span>
              </div>
            </div>
          </div>
          <div className="hero-graphic">
            <div className="hero-graphic-bg"></div>
            <div className="hero-balls">
              <div className="ball ball-1"></div>
              <div className="ball ball-2"></div>
              <div className="ball ball-3"></div>
            </div>
            <div className="hero-main-image">
              <div className="connecting-lines">
                <svg width="100%" height="100%" viewBox="0 0 300 300">
                  <path className="line line-1" d="M150,50 L50,150" />
                  <path className="line line-2" d="M150,50 L250,150" />
                  <path className="line line-3" d="M50,150 L150,250" />
                  <path className="line line-4" d="M250,150 L150,250" />
                  
                  <circle className="node node-1" cx="150" cy="50" r="8" />
                  <circle className="node node-2" cx="50" cy="150" r="8" />
                  <circle className="node node-3" cx="250" cy="150" r="8" />
                  <circle className="node node-4" cx="150" cy="250" r="8" />
                  
                  <circle className="pulse pulse-1" cx="150" cy="50" r="20" />
                  <circle className="pulse pulse-2" cx="50" cy="150" r="20" />
                  <circle className="pulse pulse-3" cx="250" cy="150" r="20" />
                  <circle className="pulse pulse-4" cx="150" cy="250" r="20" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-wave">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="wave-fill"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;